import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import {
  Validators,
  FormControl,
  FormGroup,
  FormBuilder,
} from '@angular/forms';
import { UserService } from '../../../../services/user.service';
import { CyclistService } from '../../../../services/cyclist.service';
import { PartnerService } from '../../../../services/partner.service';
import { TechnicianService } from '../../../../services/technician.service';
import { HelpersService } from '../../../../services/helpers.service';
import { OverlayPanel } from 'primeng/overlaypanel';
import { ConfirmationService } from 'primeng/api';
import { MessageService } from 'primeng/api';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import moment from 'moment';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-edit-user',
  templateUrl: './edit-user.component.html',
  styleUrls: ['./edit-user.component.scss']
})
export class EditUserComponent {

  @Input() user;
  @Input() partnerId;
  @Input() cyclistView: boolean;
  @Input() messageService: MessageService;
  @Input() technicians; //Use this to when linking a technician to see if they exist before recreating them.
  @Output() update = new EventEmitter();

  public showGDPRMarketingConsent: boolean = false;
  public isSuperUser: boolean = false;
  public busy: boolean = false;

  constructor(
    private fb: FormBuilder,
    private confirmationService: ConfirmationService,
    public helpersService: HelpersService,
    public userService: UserService,
    public cyclistService: CyclistService,
    public partnerService: PartnerService,
    public technicianService: TechnicianService,
    public modal: NgbActiveModal,
    private translate: TranslateService,
  ) {
    var partnerData = helpersService.getPartnerData();
    this.showGDPRMarketingConsent = partnerData.ShowGDPRMarketingConsent;
  }

  ngOnInit() {
    this.isSuperUser = this.helpersService.getProfileData().IsSuperUser;
  }

  updateUser() {
    let cyclist = this.user;
    cyclist.PartnerID = this.partnerId;
    console.log(cyclist);
    this.busy = true;
    this.userService.updateCustomer(cyclist).subscribe(
      (user) => {
        this.messageService.add({
          life: 5000,
          detail: this.translate.instant('messages.user_updated', {
            name: cyclist.Name,
          }),
        });
        this.busy = false;
      },
      (err) => {
        if (err.error && err.error.error && err.error.error === "CUSTOMER_EXISTS") {
          this.messageService.add({ life: 5000, detail: this.translate.instant('bikeshop.customer.error.customer_exists') });
        } else {
          this.messageService.add({ life: 5000, detail: this.translate.instant('bikeshop.customer.error.customer_general_error') });
        }
        this.busy = false;
      },
    );
  }

}
